<template>
  <div>
    <v-data-table :headers="headers" :items="complaints" :search="search" :options.sync="options" :server-items-length="totalRecords" :loading="loading" :page.sync="page">

      <template v-slot:item.description="{ item }">
        <div class="text-truncate" style="max-width: 150px">
          {{ item.description }}
        </div>
      </template>
       <template v-slot:item.house_number="{ item }">
       
            <span v-if="item.flat_name">{{ item.flat_name }}-</span>
             <span>{{ item.house_number }}</span>

        </template>
      <template v-slot:item.priority="{ item }">
        <div>
          <v-icon
            large
            :color="
              item.priority === 1
                ? '#d8d8d8'
                : item.priority === 2
                ? '#6fddff'
                : item.priority === 3
                ? '#fecb00'
                : item.priority === 0
                ? '#f50000'
                : ''
            "
          >
            mdi-flag
          </v-icon>
          {{
            item.priority === 1
              ? "Low"
              : item.priority === 2
              ? "Medium"
              : item.priority === 3
              ? "High"
              : item.priority === 0
              ? "Emergency"
              : ""
          }}
        </div>
      </template>
      <template v-slot:item.created_on="{ item }">
        {{ getFormattedDate(item.created_on) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          color="secondary"
          name="view_complaints"
          title="View Complaints"
          style="margin-left: -10px"
          :to="'/societyadmin/complaints/view/' + item.id"
        >
          <img src="@/components/icons/view.svg" width="18" height="18" />
        </v-btn>
        <v-btn
          icon
          color="secondary"
          name="delete_complaints"
          title="Delete Complaints"
          @click="confirmDelete(item.id)"
        >
          <img src="@/components/icons/delete-01.svg" width="18" height="18" />
        </v-btn>
      </template>

      <template v-slot:item.status="{ item }">
        <v-select
          v-model="item.status"
          name="status"
          :items="status"
          item-text="name"
          item-value="value"
          outlined
          sm="2"
          dense
          style="
            vertical-align: center;
            height: 53px;
            font-size: 14px;
            margin-top: 15px !important;
          "
          :class="
            item.status === 0
              ? 'Pending'
              : item.status === 1
              ? 'In_Progress'
              : item.status === 2
              ? 'Closed'
              : item.status === 3
              ? 'Cancelled'
              : ''
          "
          @change="updateStatus(item.id, item.status)"
        >
          <template v-slot:item="{ item }">
            <span :style="{ color: item.color }"> {{ item.name }} </span>
          </template>
        </v-select>
      </template>
    </v-data-table>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Confirm!! </v-card-title>
        <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteComplaints(delete_id)">
            yes
          </v-btn>
          <v-btn color="primary" text @click="closeDialog"> No </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  props: {
    cs: Number,
    parent_search: String,
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("complaints.headers.added_by")}`,
          value: "added_by",
          width: "10%",
        },
        {
          text: `${this.$t("complaints.headers.house_no")}`,
          value: "house_number",
          width: "10%",
        },
        {
          text: `${this.$t("complaints.headers.title")}`,
          value: "title",
          width: "20%",
        },
        // {
        //   text: `${this.$t("complaints.headers.description")}`,
        //   value: "description",
        //   width: "10%",
        // },

        {
          text: `${this.$t("complaints.headers.priority")}`,
          value: "priority",
          width: "13%",
        },
        {
          text: `${this.$t("complaints.headers.status")}`,
          value: "status",
          sortable: false,
          width: "17%",
        },
        {
          text: `${this.$t("complaints.headers.created_at")}`,
          value: "created_on",
          sortable: false,
          width: "15%",
        },
        {
          text: `${this.$t("complaints.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "10%",
        },
      ],
      status: [
        { name: "Pending", value: 0, color: "#a59211" },
        { name: "In Progress", value: 1, color: "#055f14" },
        { name: "Completed", value: 2, color: "#ff0202" },
        { name: "Cancelled", value: 3, color: "#000000" },
      ],

      user: {},
      addFlatDialog: false,
      editFlatDialog: false,
      deleteDialog: false,
      serverSideErrors: [],
      delete_id: "",
      complaints: [],
      options: {
        sortBy: []
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler () {
        this.getComplaints();
      },
      deep: true,
    },
    cs() {
      this.getComplaints();
    },
    parent_search() {
      this.search = this.parent_search;
      this.sessionStorage(this.search);
      this.debounceInput();
    },
    addFlatDialog() {
      if (!this.addFlatDialog) {
        this.errors = [];
      }
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getComplaints() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc = this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      let _self = this;
      _self.$axios.get(`societyadmin/complaints/open?filter=${this.cs}`+ 
          "&page=" + page +
          "&perPage=" + itemsPerPage +
          "&sortBy=" + sortBy +
          "&sortDesc=" + sortDesc +
          "&search=" + search
      )
      .then((response) => {
        _self.loading = false;

        let data = response.data;
        if (data.status) {
          _self.complaints = data.complaints;
          _self.totalRecords = data.total;
          _self.page = data.page > data.lastPage ? 1 : data.page;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
          if(data.type=='invalid'){
               localStorage.removeItem("user");
              _self.$router.push({ path: '/societyadmin/login' });
          }
        }
      });
    },
    updateStatus(Id, status_value) {
      console.log(status_value);
      let _self = this;
      _self.$axios
        .put("societyadmin/complaints/updateStatus/" + Id + "/" + status_value)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.getComplaints();

            _self.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    deleteComplaints(Id) {
      let _self = this;
      _self.$axios.delete("societyadmin/complaints/" + Id).then((response) => {
        let data = response.data;

        if (data.status) {
          _self.getComplaints();
          this.deleteDialog = false;
          this.delete_id = "";
          this.setAlert({
            showAlert: true,
            variant: "green accent-4",
            timeout: "2000",
            message: data.message,
          });
        } else {
          this.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    closeDialog() {
      this.deleteDialog = false;
      this.$validator.reset();
      this.serverSideErrors = [];
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY") : "N/A";
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("complaints_search");
      } else {
        sessionStorage.setItem("complaints_search", search);
      }
    },
    debounceInput: debounce(function(){
      this.getComplaints();
    }, 500),
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};

    // this.getComplaints();
    this.search = sessionStorage.getItem("complaints_search");
  },
};
</script>
<style  scoped>
.theme--light.v-input {
  color: rgba(192, 0, 250, 0.986);
}
.Pending .v-select__selection--comma {
  color: #a59211 !important;
}
.In_Progress .v-select__selection--comma {
  color: #055f14 !important;
}
.Closed .v-select__selection--comma {
  color: #ff0202 !important;
}
.Cancelled .v-select__selection--comma {
  color: #000000 !important;
}
.Pending .v-input__slot {
  border: 1px solid #a59211 !important;
}
.In_Progress .v-input__slot {
  border: 1px solid #055f14 !important;
}
.Closed .v-input__slot {
  border: 1px solid #ff0202 !important;
}
.Cancelled .v-input__slot {
  border: 1px solid #000000 !important;
}
</style>  